import React from 'react';
import { useState } from 'react';
import "../components/styles/Header.css";
import Bar from './Bar';


export default function Header({setShow, show}) {
    const [bar, setBar] = useState(true);

    const [change, setChange] = useState(true);
    return(
        <>
            <div className="navbar">
                <div className="container">
                    <div className="logo">
                        <a href="/#">
                            <img src="https://bedrocklauncher.github.io/static/media/BedrockLauncher_128x128.d8089ba5.png" alt="logo" />
                        </a>
                        <a href="/#" className='a'>
                        Bedrock Launcher
                        </a>
                    </div>
                    <div className="header-nav">
                        <ul>
                            <a href="/#"className='i'>
                                <i className="fas fa-magnifying-glass" onClick={() => setShow(!show)}></i>                        
                            </a>
                            <a href="/#"  onClick={() => setBar(!bar)}>
                               <i className='fas fa-bars' onClick={() => setChange(!change)}></i>
                            </a>
                        </ul>
                    </div>
                   
                </div>
            </div>
           {bar ? "" : <Bar />}
        </>
    )
};